import React from 'react';
import { useAITTheme } from '../ui/theme';

const ExternalLinkIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 473.6 496.29">
      <polygon
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        points="199.9 237.23 259.08 290.73 397.17 138 463.68 204.52 465.69 19.25 280.43 21.27 340.69 81.52 199.9 237.23"
      />
      <polygon
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        points="420.51 248.15 420.51 431.86 53.09 431.86 53.09 64.43 236.8 64.43 236.8 18.84 7.49 18.84 7.49 477.45 466.11 477.45 466.11 248.15 420.51 248.15"
      />
    </svg>
  );
};

export default ExternalLinkIcon;
